module.exports = "https://img.xiyuyouxi.com/saas/img/dele_mark.7d780848.png";